export const WITHDRAW_ROOT_ROUTE = '/account/withdraw'

export const routes = {
  home: `${WITHDRAW_ROOT_ROUTE}`,
  activityStatements: '/account/activity-statements',
} as const

export const desktopRoutes = {
  transactionHistory: '/account/summary',
}
